import "./App.css";

import AOS from "aos";
import "aos/dist/aos.css";

import { useEffect } from "react";

import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";

// =========================================================
// CLIENT LAYOUT
// =========================================================

import Navbar from "./Layout/Navbar";
import Footer from "./Layout/Footer";

// =========================================================
// CLIENT PAGES
// =========================================================

import Home from "./Pages/Home";
import Services from "./Pages/Services";
import Contact1 from "./Pages/Contact1";
import Portfolio from "./Pages/Portfolio";
import About from "./Pages/About";

// =========================================================
// ADMIN PAGES
// =========================================================

import AdminContacts from "./lifetimeMyAdmin/AdminContacts";
import AdminLogin from "./lifetimeMyAdmin/AdminLogin";
import ProtectedRoute from "./lifetimeMyAdmin/ProtectRoute";

// =========================================================
// COMMON COMPONENTS
// =========================================================

import ScrollToTop from "./Pages/ScrollToTop";

// =========================================================
// STYLES
// =========================================================

import "./Styles/Footer.css";
import "./Styles/Navbar.css";
import "./Styles/About.css";
import "./Styles/Contact.css";
import "./Styles/Home.css";
import "./Styles/PortfolioSection.css";
import "./Styles/Services.css";
import "./Styles/Portfolio.css";
import "./Styles/AdminLogin.css";

// Admin styles
import "./lifetimeMyAdmin/adminContacts.css";
import "./lifetimeMyAdmin/portfolioform.css";
import AdminDashboard from "./lifetimeMyAdmin/AdminDshboard";
import ForgotPassword from "./lifetimeMyAdmin/ForgotPassword";

// =========================================================
// LAYOUT
// =========================================================

function Layout() {
  const location = useLocation();

  // Check whether current page is admin page
  const isAdmin = location.pathname.startsWith("/lifetimeMyAdmin");

  return (
    <div className="scroll">
      {/* ===================================================
          SCROLL TO TOP
      =================================================== */}

      <ScrollToTop />

      {/* ===================================================
          CLIENT NAVBAR
          Hidden on admin pages
      =================================================== */}

      {!isAdmin && <Navbar />}

      {/* ===================================================
          ROUTES
      =================================================== */}

      <Routes>
        {/* =================================================
            CLIENT ROUTES
        ================================================= */}

        <Route path="/" element={<Home />} />

        <Route path="/home" element={<Home />} />

        <Route path="/services" element={<Services />} />

        <Route path="/about" element={<About />} />

        <Route path="/contact" element={<Contact1 />} />

        <Route path="/portfolio" element={<Portfolio />} />

        {/* =================================================
            ADMIN LOGIN
        ================================================= */}

        <Route path="/lifetimeMyAdmin" element={<AdminLogin />} />

        {/* =================================================
            ADMIN DASHBOARD
        ================================================= */}

        <Route
          path="/lifetimeMyAdmin/dashboard"
          element={
            <ProtectedRoute>
              <AdminDashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/lifetimeMyAdmin/forgot-password"
          element={<ForgotPassword />}
        />
      </Routes>

      {/* ===================================================
          CLIENT FOOTER
          Hidden on admin pages
      =================================================== */}

      {!isAdmin && <Footer />}
    </div>
  );
}

// =========================================================
// MAIN APP
// =========================================================

function App() {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
      offset: 100,
      easing: "ease-in-out",
    });
  }, []);

  return (
    <Router>
      <Layout />
    </Router>
  );
}

export default App;
